var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 48,
    viewBox: "0 0 43 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3151 4.20243C42.3151 3.37644 41.8764 2.81363 41.0828 2.62063C38.2113 1.89387 35.2983 1.34219 32.3599 0.96864C30.2437 0.716253 28.1139 0.505705 25.9855 0.369389C24.3335 0.264116 22.6734 0.291109 21.0174 0.278962C18.4154 0.250956 15.8141 0.377146 13.2271 0.656868C11.8221 0.818827 10.4171 0.978088 9.02021 1.19133C6.64885 1.55439 4.29908 2.03352 1.96956 2.61118C1.11658 2.82308 0.694131 3.34405 0.694131 4.22808V14.9498H0.686033C0.686033 18.2578 0.668488 21.5632 0.696831 24.8725C0.698088 26.0549 0.769747 27.2361 0.911427 28.41C1.24749 31.0135 2.34747 33.2971 4.02645 35.3014C5.84985 37.4689 7.93103 39.3666 10.1337 41.1265C13.0739 43.4612 16.2261 45.5158 19.5489 47.2634C20.8662 47.9599 22.1727 47.9693 23.4751 47.2446C24.5386 46.6534 25.6116 46.0771 26.6522 45.4454C30.6837 42.9958 34.4101 40.1548 37.6844 36.7428C38.9396 35.4363 40.0557 34.03 40.8723 32.3996C41.952 30.2401 42.2962 27.916 42.3043 25.542C42.3299 18.4292 42.3151 11.3152 42.3151 4.20243ZM7.92293 28.9823H5.57317V10.176H7.92293V28.9823ZM12.9342 25.0223H10.5831V14.136H12.9342V25.0223ZM17.8834 27.0023H15.5323V12.156H17.8834V27.0023ZM22.8313 31.9515H20.4816V7.20679H22.8313V31.9515Z",
    fill: "#268334"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLogo);
export default __webpack_public_path__ + "static/media/auth-logo.82a4187ff2c74c5334e113a804bbecdf.svg";
export { ForwardRef as ReactComponent };